import { title } from "assets/jss/material-kit-react.js";

const productStyle = {
  section: {
    padding: "70px 0",
    textAlign: "center"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: "#000000",
    fontFamily: 'Lucida Console',
  },
  simpleMargin: {
    padding: "20px 0",
  },
};

export default productStyle;
